"use client"
import type { SwapProtocolIdentifier } from "@opensea/graphql"
import { parseAsStringLiteral, useQueryState } from "nuqs"
import { QUERY_PARAM_KEYS } from "./keys"

// List of all available swap protocols and the "all" option
export const SWAP_PROTOCOLS: SwapProtocolIdentifier[] = [
  "opensea",
  "uniswap",
  "orca",
  "raydium",
  "pancake_swap",
  "aerodrome",
  "pumpfun",
  "meteora",
  "solfi",
]

export type RelayerQueryParam = (typeof SWAP_PROTOCOLS)[number]

const parser = parseAsStringLiteral(SWAP_PROTOCOLS)

export function useRelayerQueryParam({
  shallow = true,
}: {
  shallow?: boolean
} = {}) {
  // Since GraphQL only accepts a single swapProtocol value, we use single selection
  const [value, setValue] = useQueryState(
    QUERY_PARAM_KEYS.relayer,
    parser.withOptions({ shallow }),
  )

  async function onSelectRelayer(relayer: SwapProtocolIdentifier) {
    // Toggle selection - if same relayer is clicked, deselect it
    const newValue = value === relayer ? null : relayer

    await setValue(newValue)
  }

  async function setRelayer(relayer: SwapProtocolIdentifier | null) {
    await setValue(relayer)
  }

  async function clearRelayer() {
    // Clear should set to "all" to show all relayers
    await setValue(null)
  }

  return {
    relayer: value,
    // For compatibility with components expecting an array
    relayers: value ? [value] : [],
    onSelectRelayer,
    setRelayer,
    clearRelayer,
    hasRelayerFilter: value !== null,
  }
}
